import { render, staticRenderFns } from "./PushDetail.vue?vue&type=template&id=7e0bb46b&"
import script from "./PushDetail.vue?vue&type=script&lang=ts&"
export * from "./PushDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports